// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"143":"app","736":"vendor"}[chunkId] + "." + {"143":"653b59fb","736":"ffa22b8f"}[chunkId] + ".css";
};